export default __webpack_public_path__ + "static/testimonial__1-e04a1991348ea8fba9cf82b8de276949.jpg";